import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import api from '@/api'
import Buefy from 'buefy'
import BulmaLayout from './plugins/bulma-layout'
import FontAwesome from './plugins/font-awesome'
import Spinner from './components/helpers/Spinner'
import PdfLink from '@/components/structures/PdfLink'

import './assets/bulma-base.scss'

Vue.config.productionTip = false

Vue.use(Buefy, {
  defaultIconPack: 'fa',
  defaultIconComponent: 'font-awesome-icon'
})
Vue.use(BulmaLayout)
Vue.use(FontAwesome)

Vue.component('loading-spinner', Spinner)
Vue.component('pdf-link', PdfLink)

Vue.filter('capitalizeFirstLetter', string => string.charAt(0).toUpperCase() + string.slice(1))
Vue.filter('underscoresToSpaces', string => string.split('_').join(' '))
Vue.filter('nullToDash', string => string || '-')

const token = localStorage.getItem('token')
if (token) {
  api.defaults.headers.common['Authorization'] = `Token ${token}`
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
